module.exports = __webpack_public_path__ + "img/music-player-details2.478e280c.png";